import { Button, ButtonGroup, Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

let WholePortionWetPreparationSingleTraySection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
  prefixName,
}) => {
  const dispatch = useDispatch();

  const trays = useSelector(createWorksheetSelector!('MassMeasurement.WetMassMeasurements'), deepEquals) as any[];

  const updateTrays = (value: any[]) => {
    dispatch(
      actions.setValue({
        name: prefixName!('MassMeasurement.WetMassMeasurements'),
        value: value,
        sync: true,
      })
    );
  };

  return (
    <>
      <NamePrefixModifier appendNamePrefix="MassMeasurement">
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Equipment.Balance" />
          <Field input={<NumericInput />} name="WetMassMeasurements[0].TareMass" />
          <FieldSet>
            <Field input={<NumericInput />} name="WetMassMeasurements[0].TareAndWetMass" />
            <ButtonGroup>
              <Button onClick={() => updateTrays([...trays, {}])}>Add Tray</Button>
            </ButtonGroup>
          </FieldSet>
          <Field input={<TextOutput />} name="WetMass" />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};

WholePortionWetPreparationSingleTraySection = withInjectedProps(WholePortionWetPreparationSingleTraySection);

export { WholePortionWetPreparationSingleTraySection };
export default WholePortionWetPreparationSingleTraySection;
